import { google as GoogleIma, loadImaSdk } from '@alugha/ima'

// eslint-disable-next-line import/prefer-default-export
export class ImaService {
  private ima: typeof GoogleIma.ima | null = null
  private loadingPromise: Promise<typeof GoogleIma.ima> | null = null

  async initialize(): Promise<typeof GoogleIma.ima> {
    if (this.ima) {
      return this.ima
    }

    if (this.loadingPromise) {
      return this.loadingPromise
    }

    this.loadingPromise = loadImaSdk()
      .then((ima) => {
        this.ima = ima
        return ima
      })
      .catch((error) => {
        this.loadingPromise = null
        // eslint-disable-next-line no-console
        console.error('IMA SDK failed to load:', error)
        throw new Error('Ad blocker or network issue prevented IMA SDK loading')
      })

    return this.loadingPromise
  }

  async AdDisplayContainer(
    containerElement: HTMLDivElement | null,
    videoElement?: HTMLVideoElement
  ): Promise<GoogleIma.ima.AdDisplayContainer> {
    if (!containerElement) {
      throw new Error('Container element is required for AdDisplayContainer')
    }
    const ima = await this.initialize()
    return new ima.AdDisplayContainer(containerElement, videoElement)
  }

  async AdsLoader(
    adDisplayContainer: GoogleIma.ima.AdDisplayContainer
  ): Promise<GoogleIma.ima.AdsLoader> {
    const ima = await this.initialize()
    return new ima.AdsLoader(adDisplayContainer)
  }

  async AdsRequest(): Promise<GoogleIma.ima.AdsRequest> {
    const ima = await this.initialize()
    return new ima.AdsRequest()
  }

  async AdsRenderingSettings(): Promise<GoogleIma.ima.AdsRenderingSettings> {
    const ima = await this.initialize()
    return new ima.AdsRenderingSettings()
  }

  async getEventTypes(): Promise<{
    AdEvent: typeof GoogleIma.ima.AdEvent
    AdErrorEvent: typeof GoogleIma.ima.AdErrorEvent
    AdsManagerLoadedEvent: typeof GoogleIma.ima.AdsManagerLoadedEvent
    ViewMode: typeof GoogleIma.ima.ViewMode
  }> {
    const ima = await this.initialize()
    return {
      AdEvent: ima.AdEvent,
      AdErrorEvent: ima.AdErrorEvent,
      AdsManagerLoadedEvent: ima.AdsManagerLoadedEvent,
      ViewMode: ima.ViewMode,
    }
  }

  destroy(): void {
    this.ima = null
    this.loadingPromise = null
  }
}
